@if (sortedCurrencyTotals().length) {
    <section class="total-footer-price-final" data-cy="BASKET_CURRENCY_TOTALS">
        <div class="total-footer-price-wrapper">
            @for (currencyTotal of sortedCurrencyTotals(); track $index) {
                <div class="d-flex justify-content-between">
                    <strong class="text-primary font-9">
                        {{ 'Summe netto' | translate }}
                    </strong>
                    <strong class="font-9 text-end">
                        <display-currency [value]="currencyTotal.netTotal.amount" [currencyCode]="currencyTotal.netTotal.currency" />
                    </strong>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-column">
                        @for (tax of currencyTotal.taxBreakdown; track $index) {
                            <strong class="font-9">
                                {{ 'zzgl. \{\{value\}\}% MwSt.' | translate: { value: tax.taxRate } }}
                            </strong>
                        }
                    </div>
                    <div class="d-flex flex-column">
                        @for (tax of currencyTotal.taxBreakdown; track $index) {
                            <strong class="font-9 text-end">
                                <display-currency [value]="tax.totalAmount.amount" [currencyCode]="tax.totalAmount.currency" />
                            </strong>
                        }
                    </div>
                </div>
                <div class="d-flex justify-content-between mt-2">
                    <strong class="font-13 text-primary">
                        {{ 'Summe brutto' | translate }}
                    </strong>
                    <strong class="font-13 text-end">
                        <display-currency [value]="currencyTotal?.grossTotal?.amount" [currencyCode]="currencyTotal?.grossTotal?.currency" />
                    </strong>
                </div>
            }
        </div>
    </section>
}
